import { render } from "./TriviaQuestions.vue?vue&type=template&id=28eeb5e1&scoped=true"
import script from "./TriviaQuestions.vue?vue&type=script&lang=js"
export * from "./TriviaQuestions.vue?vue&type=script&lang=js"

import "./TriviaQuestions.vue?vue&type=style&index=0&id=28eeb5e1&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28eeb5e1"]])

export default __exports__